import { getTranslationOrInnerText, isHTMLElement } from 'whisper-base';
import { NudgeTypes } from '../constants';
export const Definition = {
  // Upgrade banners do not use the Trellis inline alert component so won't have the data-alert-type
  // attribute but do have the role of alert and are configured to include the nudge type
  selector: `:not([data-alert-type])[role="alert"][data-nudge-type="${NudgeTypes.ALERT_INLINE}"]`,
  getNudgeProperties: ({
    element
  }) => {
    var _titleElement$nextSib;
    // Get the first strong tag, this is always present and contains the title
    const titleElement = element.querySelector('strong');
    const title = isHTMLElement(titleElement) ? getTranslationOrInnerText(titleElement) : 'no-title';

    // There is a whitespace text node and then the banner contents which could
    // be a text node (when a raw string is used) or an element (such as formatted message)
    const bodyNode = titleElement === null || titleElement === void 0 || (_titleElement$nextSib = titleElement.nextSibling) === null || _titleElement$nextSib === void 0 ? void 0 : _titleElement$nextSib.nextSibling;
    let text = 'no-text';
    if (bodyNode) {
      if (isHTMLElement(bodyNode)) {
        text = getTranslationOrInnerText(bodyNode);
      } else if (bodyNode.nodeType === Node.TEXT_NODE && bodyNode.textContent) {
        // Most upgrade banners are just text nodes and not wrapped in another element
        text = bodyNode.textContent;
      }
    }
    const id = element.getAttribute('data-test-id');
    return Object.assign({
      type: NudgeTypes.ALERT_INLINE
    }, id ? {
      id
    } : {}, {
      title,
      text
    });
  }
};